import React, {Component} from 'react';
import PropTypes from 'prop-types';
import { __ } from 'i18n-for-browser';

/**
 * Import assets
 */
import Star from '../../assets/img/icons/star.svg';
import Global from '../../assets/img/icons/global.svg';
import Check from '../../assets/img/icons/check.svg';
import PopupTitle from "./PopupTitle";
import policyIcon from '../../assets/img/icons/economy/beleidskeuze.png';
import budgetIcon from '../../assets/img/icons/globas_trimmed.png';
import ramp from '../../assets/img/icons/ramp.png';
import rampEN from '../../assets/img/icons/disaster.png';
import connect from "react-redux/es/connect/connect";
import {getUnreadCount, getMinistryColor, ministryHasDisaster} from '../../helpers/feedbackHelpers';
import config from '../../config';

class ListButton extends Component {
  static propTypes = {
    opacity: PropTypes.bool,
    bgColor: PropTypes.string,
    ministry: PropTypes.string,
    className: PropTypes.string,
    subtitle: PropTypes.string,
    disabled: PropTypes.bool,
    onClick: PropTypes.func,
    reverseGlobasPoints: PropTypes.bool,
  };
  static defaultProps = {
    reverseGlobasPoints: false,
    opacity: false,
    bgColor: '',
    className: '',
    disabled: false,
    subtitle: '',
    hideDisaster: false,
    onClick: () => {},
  };
  constructor(props) {
    super(props);
    this.additionalClasses = this.props.className;
  }

  addStars(amount) {
    let stars = [];

    for (let i = 0; i < amount; i++) {
      stars.push(<img alt="star" className='star-icon' key={i} src={Star} />);
    }

    return stars;
  }

  /**
   * @name handleClick
   * @description Method to handle click event
   */
  handleClick = () => {
    if (!this.props.disabled) {
      this.props.onClick();
    }
  };

  render() {
    const {props} = this;
    const {schoolClass, ministry, gameState, gameStateInput, feedbackItems} = props;

    const groupBadge = (name, i) => {
      let matchedGroup = schoolClass.Groups.find(g => g.GroupTheme.color === name);
      if (matchedGroup) return <img key={i} className={'collab-inline-item-badge'} src={`${config.apiUrl}${matchedGroup.GroupTheme.badge}`} alt={'badge'} />;
    };

    let bgColor = (this.props.feedback && (!this.props.read && this.props.bgColor === 'grey') ? 'white': this.props.bgColor);
    const difficulty = this.props.project.difficulty.toLowerCase();
    let unreadCount = this.props.feedbackCount;
    let {disaster, hidePoints, points} = this.props;
    let id = "false";
    if(ministry) {
      id = ("scrollto-"+ministry).toLowerCase();
      bgColor = getMinistryColor(difficulty, ministry, gameState, gameStateInput, feedbackItems.prevRoundFeedbackData);
      unreadCount = getUnreadCount(ministry, feedbackItems.prevRoundFeedbackData);
      disaster = gameState.currentStep === 1 && ministryHasDisaster(ministry, feedbackItems);
      if(gameState.currentRound===1){
        points = false;
        hidePoints = true;
      }
    } else if(this.props.className.indexOf("total-economy-list-button") > -1) {
      id = "scrollto-economy";
    } else if(this.props.className.indexOf("beleidskeuze-listbutton-laag") > -1) {
      id = "scrollto-beleidskeuzes";
    }
    return (
      <div id={id} onClick={this.handleClick} className={`list-button${this.props.disabled ? ' disabled' : ''} ${bgColor} ${(this.props.policy ? ' policy' : '')} ${(this.props.arrow ? ' arrow' : '')} ${(disaster && !this.props.hideDisaster ? ' disaster' : '')} ${(this.props.bigArrow ? ' big-arrow' : '')} ${this.additionalClasses}`}>
        <div className='inner-list-button'>
          <div className='icon'>
            {this.props.thumbnail !== undefined && this.props.thumbnail !== "" ?
              <div className="Imagio" style={{backgroundImage: `url(${this.props.thumbnail})`}}>
                {this.props.icon ?
                  <img alt="icon" src={this.props.icon}/>
                : null }

              </div>
              :
              this.props.icon ?
                <img alt="icon" src={this.props.icon}/>
              : null
            }
            {unreadCount > 0 ?
              <div className={`notification-count${(this.props.redNotification ? ' red' : '')}`}>
                <span><p>{unreadCount}</p></span>
              </div> :
            ''}

            {this.props.checked ?
              <img alt="check" src={Check}/>
             : ''}
          </div>

          {this.props.feedback ?
            <div className={'title-block title-feedback' + (this.props.read === undefined || !this.props.read ? " unread" : "")}>
              {this.props.popupId ?
                <PopupTitle popupId={this.props.popupId} tag={'h4'}/> :
                <h4 className={this.props.hideOverflow ? "hide-overflow" : ""}>{this.props.title.charAt(0).toUpperCase() + this.props.title.slice(1)}</h4>
              }
              <span dangerouslySetInnerHTML={{ __html: this.props.desc }}/>
            </div>
            :
            <div className='title-block'>
              {gameState.difficulty === 'PRO' ?
                <div className='stars-container'>
                  {this.addStars(this.props.stars)}
                </div> : ''
              }

                <h4 className={this.props.hideOverflow ? "hide-overflow" : ""}>
                  {this.props.global ? <img alt="globalIcon" className='global-icon' src={Global} /> : ''} {this.props.title}
                </h4>
                {this.props.popupId ?
                  <PopupTitle onlyQ={true} popupId={this.props.popupId}/> :
                  null
                }

            {(this.props.subtitle.length ? (
              <p className={'subtitle'}>{this.props.subtitle}</p>
            ) : null)}
            </div>
          }

          {this.props.budgetSet || this.props.policySet ?
            <div className={'policy-img'}>
              {this.props.budgetSet ?
                <img src={budgetIcon} className={'budget-flag'} alt="Budget"/> : ''
              }
              {this.props.policySet ?
                <img src={policyIcon} className={'policy-flag'} alt="Policy"/> : ''
              }
            </div> : ''
          }
          <div className={'point-holder ' + (this.props.reverseGlobasPoints ? 'reverse' : '')}>
            {this.props.globas !== undefined ?
              <li>
                <span title={this.props.globas < 0 ? '- ' + Math.abs(this.props.globas) : this.props.globas}>{this.props.globas < 0 ? '- ' + Math.abs(this.props.globas) : this.props.globas}</span>
                <p title={__('sim_miljard')}>{__('sim_miljard')}</p>
              </li> :
            ''}
            {points !== undefined && points !== false ?
              <li>
                {(this.props.dashForZero ?
                  <span title={(points === '+0' || points === '-0' ? '-' : points)}>{(points === '+0' || points === '-0' ? '-' : points)}</span>
                  :
                  <span title={points < 0 ? '- ' + Math.abs(points) : points}>{points < 0 ? '- ' + Math.abs(points) : points}</span>
                )}
                {this.props.isGlobas !== undefined && this.props.isGlobas !== false ?
                  <p title={__('sim_miljard')}>{__('sim_miljard')}</p>
                  :
                  <p title={__('sim_punten')}>{__('sim_punten')}</p>
                }
              </li> :
              ''}
            {points === undefined && hidePoints === undefined ?
              <li className="placeholder">
                <span title={'0'}>0</span>
                <p title={__('sim_punten')}>{__('sim_punten')}</p>
              </li> :
            ''}
          </div>

          {this.props.collaboration ?
            <div className={'collab-icons'}>
              {this.props.collaboration.map((group, i) => (
                <span key={i}>
                  {groupBadge(group, i)}
                </span>
              ))}
            </div>
            : null }

          {disaster && !this.props.hideDisaster ?
            <img className={'disaster-icon'} src={this.props.gameState.language === "NL" ? ramp : rampEN} alt={'disaster'}/>
            : null }

          {this.props.arrow || this.props.bigArrow ? <div className='arrow-block'/> : ''}

          {this.props.children ?
            <div className={'policy-data'}>{this.props.children}</div> : ''
          }
        </div>
      </div>
    );
  }
}

export default connect(({schoolClass, gameState, gameStateInput, feedback, project}) => ({schoolClass, gameState, gameStateInput, feedbackItems:feedback, project}))(ListButton);



// WEBPACK FOOTER //
// ./src/components/elements/ListButton.js